import { c as _c } from "react/compiler-runtime";
import { Card, Flex, Text } from '@endurancewarranty/ui';
import type { HttpErrorResponse } from '@endurancewarranty/lib';
import type { TAppError } from '@lib/states/error/errorAtom';
import type { FC } from 'react';
type Props = Readonly<{
  errors: TAppError[];
  isExpandedInitial?: boolean;
}>;
export const ErrorModalErrorDetails: FC<Props> = t0 => {
  const $ = _c(5);
  const {
    errors
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Flex justify="between"><Text.Body size="sm" fontWeight="medium">Troubleshooting Details</Text.Body></Flex>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== errors) {
    t2 = errors.map(_temp);
    $[1] = errors;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Card backgroundColor={50} className="mt-3 max-h-[300px] overflow-y-auto p-2" roundedSize="lg" width="full">{t1}{t2}</Card>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(e, i) {
  if (e.error.name === "AbortError" || e.error.name === "TimeoutError") {
    return <Flex key={i} direction="col" className="mt-4 border-t border-t-gray-200 first:mt-2"><Text.Body>The request was aborted because it took too long.</Text.Body></Flex>;
  }
  const err = e.error as HttpErrorResponse;
  const metadata = err.getHttpErrorMetadata();
  return <Flex key={i} direction="col" className="mt-4 border-t border-t-gray-200 first:mt-2"><div className="mt-2"><Text.Body fontWeight="medium" size="sm">{metadata.method} {metadata.endpoint}</Text.Body><Text.Body margin="mt-1"><Text.Body fontWeight="medium">Correlation ID:</Text.Body><Text.Body>{metadata.correlationId}</Text.Body></Text.Body><Text.Body><Text.Body fontWeight="medium">Status:</Text.Body>{metadata.statusCode} - {metadata.statusMessage}</Text.Body></div></Flex>;
}